import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Paginacao } from '../../comum/modelos/paginacao';
import { OcorrenciasService } from '../ocorrencias.service';
import { Ocorrencia } from '../../comum/modelos/ocorrencia';
import { FiltroOcorrencia } from '../../comum/modelos/filtro-ocorrencia';
import { Data } from '../../comum/data/data';

@Component({
  selector: 'app-listar-ocorrencias-grafico',
  templateUrl: './listar-ocorrencias-grafico.component.html',
  styleUrls: ['./listar-ocorrencias-grafico.component.css']
})
export class ListarOcorrenciasGraficoComponent implements OnInit {
  filtroPesquisaNomePontoFisico: string;
  filtroOcorrencia: FiltroOcorrencia;
  ocorrencias: Ocorrencia[];
  origem: string;
  statusCode: number;

  public paginacao: Paginacao;
  public loading = false;

  constructor(
    private _ocorrenciasService: OcorrenciasService,
    private data: Data,
    private _activatedRoute: ActivatedRoute) {
    this.ocorrencias = new Array<Ocorrencia>();
    this.filtroOcorrencia = new FiltroOcorrencia();
    this.paginacao = new Paginacao();
    this.loading = false;
  }

  ngOnInit() {
    const self = this;
    self.paginacao.itens = 5;
    self.paginacao.page = 1;
    self.loading = true;
    self.filtroOcorrencia = this.data.storage.filtroOcorrencia;
    self.origem = this._activatedRoute.snapshot.params['origem'];
    if (self.origem.toString() === 'PONTO-FISICO') {
      self._ocorrenciasService.obterOcorrenciasPorPontoFisicoGraficoHttp(self.filtroOcorrencia).subscribe(ocorrencias => {
        this.ocorrencias = ocorrencias.body;
        this.data.storage = {
          'filtroOcorrencia': this.filtroOcorrencia
        };
        self.loading = false;
      });
    }
    if (self.origem.toString() === 'STATUS') {
      self._ocorrenciasService.obterOcorrenciasPorStatusGraficoHttp(self.filtroOcorrencia).subscribe(ocorrencias => {
        this.ocorrencias = ocorrencias.body;
        this.data.storage = {
          'filtroOcorrencia': this.filtroOcorrencia
        };
        self.loading = false;
      });

    }
    if (self.origem.toString() === 'TIPO') {
      self._ocorrenciasService.obterOcorrenciasPorTipoGraficoHttp(self.filtroOcorrencia).subscribe(ocorrencias => {
        this.ocorrencias = ocorrencias.body;
        this.data.storage = {
          'filtroOcorrencia': this.filtroOcorrencia
        };
        self.loading = false;
      });
    }
    if (self.origem.toString() === 'DIARIA') {
      self._ocorrenciasService.obterOcorrenciasPorDiaGraficoHttp(self.filtroOcorrencia).subscribe(ocorrencias => {
        this.ocorrencias = ocorrencias.body;
        this.data.storage = {
          'filtroOcorrencia': this.filtroOcorrencia
        };
        self.loading = false;
      });
    }
  }

  pesquisarPorFiltro(filtro: any): void {
    this.filtroPesquisaNomePontoFisico = filtro.value;
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/ocorrencias/listar-ocorrencias-grafico/listar-ocorrencias-grafico.component.ts